import classes from "./BlogHeading.module.css";

const BlogHeading = () => {
  return (
    <>
      <div className={classes.BlogHeading}>
        <h1>THINGS TO READ</h1>
      </div>
    </>
  );
};

export default BlogHeading;
